module.exports = __webpack_public_path__ + "img/EMS_user_manual_timeline2.2ea427cd.png";